import React, {Component} from 'react';
import { Toast, ActivityIndicator, NoticeBar } from 'antd-mobile';
import DataFetcher from '../utils/DataFetcher';
import CommonUtils from '../utils/CommonUtils';
import Constants from '../utils/Constants';
import '../styles/GoldPlan.css';
import iconLogo from '../medias/logo.jpg';

class GoldPlan extends Component {
    constructor(props) {
        super(props);

        this.state = {
            orderDetail: {}
        }
    }

    componentDidMount() {
        if(window.parent && window.parent.postMessage) {
            let mchData ={action:'onIframeReady', displayStyle:'SHOW_CUSTOM_PAGE', height: 800}
            let postData = JSON.stringify(mchData)
            window.parent.postMessage(postData, 'https://payapp.weixin.qq.com')
        }
        this.outTradeNo = CommonUtils.resolveSearchParam(this.props.location, 'out_trade_no')
        this.loadData()
    }

    loadData = () => {
        this.loadOrderDetail((data) => {
            if(CommonUtils.isEmpty(data.orderNo)) {
                setTimeout(() => {
                    this.loadOrderDetail()
                }, 2000)
            }
        })
    }

    loadOrderDetail = (callback) => {
        if(CommonUtils.isEmpty(this.outTradeNo)) {
            this.outTradeNo = CommonUtils.resolveSearchParam(this.props.location, 'out_trade_no')
        }

        DataFetcher.orderDetail({
            payChannel: 'QFL',
            transactionId: this.outTradeNo
        }, { 
            success: (resp) => {
                this.setState({
                    orderDetail: resp.data
                }, () => {
                    callback&&callback(resp.data)
                })
            }
        })
    }

    handleBtnBackClick = () => {
        if(!window.parent || !window.parent.postMessage) {
            Toast.info("请刷新页面", 3)
            return
        }

        const { orderDetail } = this.state
        let jumpOutUrl = 'https://wx.twinhouse.cn/#/user'
        if(CommonUtils.isNotEmpty(orderDetail.goldPlanJumpOut)) {
            jumpOutUrl = orderDetail.goldPlanJumpOut
        }

        let mchData ={action:'jumpOut', jumpOutUrl}
        let postData = JSON.stringify(mchData)
        window.parent.postMessage(postData,'https://payapp.weixin.qq.com')
    }

    handleBtnRefreshClick = () => {
        this.loadOrderDetail()
    }

    doResolveOrderType = (order) => {
        if(order.orderType === 'RECHARGE') {
            return '优惠充值'
        } else if(order.orderType === 'PACKET') {
            return '游戏套餐'
        } else {
            return '未知'
        }
    }

    generateSpecifiedOrderItem = () => {
        const {orderDetail} = this.state
        if(CommonUtils.isNotEmpty(orderDetail.deviceName)) {
            return (
                <div className='order-item'>
                    <div className='label'>设备编号</div>
                    <div className='value word-ellipsis'>{orderDetail.deviceName}</div>
                </div>
            )
        }

        if(CommonUtils.isNotEmpty(orderDetail.deviceId)) {
            return (
                <div className='order-item'>
                    <div className='label'>设备编号</div>
                    <div className='value word-ellipsis'>{orderDetail.deviceId}</div>
                </div>
            )
        }

        if(CommonUtils.isNotEmpty(orderDetail.couponCode)) {
            return (
                <div className='order-item'>
                    <div className='label'>优惠券码</div>
                    <div className='value word-ellipsis'>{orderDetail.couponCode}</div>
                </div>
            )
        }
    }

    doRenderOrderView = () => {
        const {orderDetail} = this.state

        if(CommonUtils.isEmpty(orderDetail.orderNo)) {
            return (
                <div className='wrapper-loading'>
                    <ActivityIndicator text='订单信息加载中...'/>
                </div>
            )
        }

        return (
            <div className='wrapper-order'>
                {this.generateSpecifiedOrderItem()}
                <div className='order-item'>
                    <div className='label'>剩余时间</div>
                    <div className='value word-ellipsis'>{CommonUtils.readableGameMinutes(orderDetail.gameMinutes)}</div>
                </div>
                <div className='order-item'>
                    <div className='label'>账户余额</div>
                    <div className='value word-ellipsis'>￥{orderDetail.balance?orderDetail.balance:0}</div>
                </div>
                <div className='order-item'>
                    <div className='label'>订单金额</div>
                    <div className='value word-ellipsis'>￥{orderDetail.orderPrice}</div>
                </div>
                <div className='order-item'>
                    <div className='label'>订单类型</div>
                    <div className='value word-ellipsis'>{this.doResolveOrderType(orderDetail)}</div>
                </div>
                <div className='order-item'>
                    <div className='label'>订单编号</div>
                    <div className='value'>{orderDetail.orderNo}</div>
                </div>
            </div>
        )
    }

    doRenderActionView = () => {
        const { orderDetail } = this.state

        if(orderDetail.orderType === 'RECHARGE') {
            return (
                <div className="wrapper-action">
                    <button className="btn-back" onClick={this.handleBtnBackClick}>余额兑换游戏套餐</button>
                </div>
            )
        }

        if(orderDetail.orderType === 'PACKET') {
            return (
                <div className="wrapper-action">
                    <button className="btn-back" onClick={this.handleBtnBackClick}>用户中心</button>
                </div>
            )
        }

        return (
            <div className="wrapper-action">
                <button className="btn-back" onClick={this.handleBtnRefreshClick}>刷新</button>
            </div>
        )
    }

    doRenderTipView = () => {
        const { orderDetail } = this.state

        if(CommonUtils.isEmpty(orderDetail.deviceId) && CommonUtils.isNotEmpty(orderDetail.couponCode)) {
            return (
                <NoticeBar marqueeProps={{ loop: true, style: { padding: '0 7.5px' } }}>
                    请扫描设备屏幕上的二维码来启动设备！
                </NoticeBar>
            )
        }

        if(orderDetail.orderType === 'RECHARGE') {
            return (
                <NoticeBar marqueeProps={{ loop: true, style: { padding: '0 7.5px' } }}>
                    用余额兑换完游戏套餐后，才能启动设备哦！
                </NoticeBar>
            )
        }

        if(orderDetail.orderType === 'PACKET') {
            return (
                <NoticeBar marqueeProps={{ loop: true, style: { padding: '0 7.5px' } }}>
                    设备启动中！若无响应，可扫码使用其它设备！
                </NoticeBar>
            )
        }

        return (
            <NoticeBar marqueeProps={{ loop: true, style: { padding: '0 7.5px' } }}>
                支付成功！若无响应，可扫码使用其它设备！
            </NoticeBar>
        )
    }

    render() {
        const {orderDetail} = this.state
        let brandName = orderDetail ? orderDetail.brandName : null
        if(CommonUtils.isEmpty(brandName)) {
            brandName = Constants.Strings.APP_NAME
        }

        return (
            <div className="page-gold-plan">
                {this.doRenderTipView()}
                <div className='wrapper-logo'>
                    <img src={iconLogo} alt=""/>
                </div>
                <div className='wrapper-title'>{brandName}</div>
                {this.doRenderOrderView()}
                {this.doRenderActionView()}
            </div>
        )
    }
}

export default GoldPlan;


// WEBPACK FOOTER //
// ./src/modules/GoldPlan.js